import {HTTP} from "@/utils/httpCommonUtil";
import IssuableDetail from "@/components/provider/cards/issuables/IssuableDetail";
import {FacilityCredential, IssuableController} from "@/components/provider/cards/issuables/IssuableModels";
import Vue from "vue";
import {UserRoleEnum} from "@/enums/userRolesEnum";

export default Vue.component('facility-credential-detail', {
  name: 'FacilityCredentialDetail',
  props: {
    credential : {} as () => FacilityCredential,
    issuableController : Object as () => IssuableController<any>
  },
  data() {
    return {
      facilitySpecialties: [] as any[],
    }
  },
  components: {
    IssuableDetail,
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    }
  },
  filters: {
    miles (miles: any) {
      if (!miles) { return ' - miles'; }
      return miles + ' miles';
    }
  },
  methods: {

    async facilitySelected (facility: any) {
      if (this.credential.facilityId === facility.id) {
        return;
      }
      this.credential.facilityId = facility.id;
      this.credential.facilityName = facility.name;
      this.facilitySpecialties = [];
      await this.getFacilitySpecialties(facility.id);
    },
    async toggleEditCredential() {
      this.$emit('credentialSelected', this.credential.id);
      await this.getFacilitySpecialties(this.credential.facilityId);
    },
    reEmitStaleDataEvent() {
      this.$emit('staleData');
    },
    async getFacilitySpecialties(facilityId: number) {
      if (this.facilitySpecialties.length) {
        return;
      }
      try {
        const response = await HTTP.get(`/api/facilities/${facilityId}/specialties`);
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility Specialties");
        }
        this.facilitySpecialties = response.data.data.filter((specialty: any) => specialty.facilitySpecialtyAssocId);
      } catch (err) {
        console.error(err);
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialties.'
        });
        this.facilitySpecialties = [];
      }
    },
    browseToFacility (iFacility: any) {
      window.open("/facilities/" + iFacility.facilityId, '_blank');
    },
    welcomeStatusChange (credential: any) {
      credential.isWelcomed = credential.isWelcomed === 'true';
    },
    reEmitCancel(issuable : any) {
      this.$emit('cancel', issuable);
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/provider/cards/facilityCredentials/FacilityCredentialDetail.ts